import { Store, StoreConfig } from '@datorama/akita';

import { Injectable } from '@angular/core';

export interface CreateQuotationModalState {
  loading: boolean;
  errMsgs: string[];
  failed: boolean;
}

export function createInitialState(): CreateQuotationModalState {
  return {
    loading: false,
    failed: false,
    errMsgs: []
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'create-quotation-modal' })
export class CreateQuotationModalStore extends Store<CreateQuotationModalState> {
  constructor() {
    super(createInitialState());
  }
}
